import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'common_color',
  message0: '%{BKY_CUSTOM_COMMON_COLOR}',
  args0: [
    {
      type: 'field_colour',
      name: 'COLOR',
      colour: '#ff6600'
    }
  ],
  output: 'Color',
  style: 'led_blocks',
  tooltip: '%{BKY_CUSTOM_COMMON_COLOR_TOOLTIP}',
  helpUrl: '',
  mutator: 'common_color_ext'
}

Blockly.Blocks['common_color'] = {
  init: function () {
    this.jsonInit(blockJson)
    this.inputs_ = Array(OPTIONS.length).fill('FALSE')
  },
  onchange: function (event) {
    if (event.type === 'change')
      if (event.name === 'COLOR') {
        const block = Blockly.Workspace.getById(event.workspaceId).getBlockById(
          event.blockId
        )
        if (block && block.id === this.id && block.getInput('RED')) {
          const colorHex = block.getFieldValue('COLOR')
          const color = hexToRgb(colorHex)
          const redBlock = this.getInputTargetBlock('RED')
          const greenBlock = this.getInputTargetBlock('GREEN')
          const blueBlock = this.getInputTargetBlock('BLUE')
          if (redBlock && redBlock.type === 'math_number')
            redBlock.setFieldValue(color.r, 'NUM')
          if (greenBlock && greenBlock.type === 'math_number')
            greenBlock.setFieldValue(color.g, 'NUM')
          if (blueBlock && blueBlock.type === 'math_number')
            blueBlock.setFieldValue(color.b, 'NUM')
        }
      }
  }
}

function getRgbFromInputs(block) {
  let red = Blockly.Python.valueToCode(
    block,
    'RED',
    Blockly.Python.ORDER_ATOMIC
  )
  red = red ? red : 0
  let green = Blockly.Python.valueToCode(
    block,
    'GREEN',
    Blockly.Python.ORDER_ATOMIC
  )
  green = green ? green : 0
  let blue = Blockly.Python.valueToCode(
    block,
    'BLUE',
    Blockly.Python.ORDER_ATOMIC
  )
  blue = blue ? blue : 0
  return [red, green, blue]
}

Blockly.Python['common_color'] = function (block) {
  let code = ''
  if (block.getInput('RED')) {
    // extention
    const rgb = getRgbFromInputs(block)
    code = `(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`
    const colorHex = rgbToHex(rgb[0], rgb[1], rgb[2])
    block.setFieldValue(colorHex, 'COLOR')
  } else {
    // default
    let colorHex = block.getFieldValue('COLOR')
    const colorRgb = hexToRgb(colorHex)
    code = `(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b})`
  }
  return [code, Blockly.Python.ORDER_ATOMIC]
}

const OPTIONS = ['extention']
const FIELDS = ['RED', 'GREEN', 'BLUE', '']

Blockly.Blocks['common_color_ext'] = {
  init: function () {
    const TITLES = [Blockly.Msg.CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_EXTENTION]
    for (let i = 0; i < OPTIONS.length; i++) {
      this.appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(TITLES[i])
        .appendField(new Blockly.FieldCheckbox(false), OPTIONS[i])
    }
    this.setStyle('ifzero_blocks')
    this.setTooltip('')
    this.setHelpUrl('')
  }
}

Blockly.Constants.commonColor = {}
Blockly.Constants.commonColor.BORDER_MUTATOR_MIXIN = {
  connections_: Array(OPTIONS.length).fill(null),
  mutationToDom: function () {
    let container = document.createElement('mutation')
    for (let i = 0; i < this.inputs_.length; i++) {
      if (this.inputs_[i] == 'TRUE') {
        container.setAttribute(OPTIONS[i], this.inputs_[i])
      }
    }
    return container
  },
  domToMutation: function (xmlElement) {
    for (let i = 0; i < this.inputs_.length; i++) {
      this.inputs_[i] = xmlElement.getAttribute(OPTIONS[i].toLowerCase())
    }
    this.updateShape_()
  },
  decompose: function (workspace) {
    let containerBlock = workspace.newBlock('common_color_ext')
    for (let i = 0; i < this.inputs_.length; i++) {
      containerBlock.setFieldValue(this.inputs_[i], OPTIONS[i])
    }
    containerBlock.initSvg()
    return containerBlock
  },
  compose: function (containerBlock) {
    // Get check box values
    let isChenaged = false
    for (let i = 0; i < this.inputs_.length; i++) {
      if (this.inputs_[i] !== containerBlock.getFieldValue(OPTIONS[i])) {
        this.inputs_[i] = containerBlock.getFieldValue(OPTIONS[i])
        isChenaged = true
      }
    }
    if (isChenaged) this.updateShape_()
    // Reconnect any child blocks
    for (let i = 0; i < OPTIONS.length; i++) {
      if (this.getInput(OPTIONS[i])) {
        Blockly.Mutator.reconnect(this.connections_[i], this, OPTIONS[i])
      }
    }
  },
  saveConnections: function () {
    for (let i = 0; i < this.inputs_.length; i++) {
      let input = this.getInput(OPTIONS[i])
      if (input) {
        this.connections_[i] = input && input.connection.targetConnection
      }
    }
  },
  updateShape_: function () {
    FIELDS.forEach((element) => {
      if (this.getInput(element)) {
        this.removeInput(element)
      }
    })
    if (this.inputs_[0] == 'TRUE') {
      this.jsonInit({
        message0: '%{BKY_CUSTOM_COMMON_COLOR_EXT}',
        args0: [
          {
            type: 'field_colour',
            name: 'COLOR',
            colour: '#ff6600'
          },
          {
            type: 'input_value',
            name: 'RED',
            check: 'Number'
          },
          {
            type: 'input_value',
            name: 'GREEN',
            check: 'Number'
          },
          {
            type: 'input_value',
            name: 'BLUE',
            check: 'Number'
          }
        ],
        tooltip: '%{BKY_CUSTOM_COMMON_COLOR_EXT_TOOLTIP}'
      })
    } else {
      this.jsonInit({
        message0: '%{BKY_CUSTOM_COMMON_COLOR}',
        args0: [
          {
            type: 'field_colour',
            name: 'COLOR',
            colour: '#ff6600'
          }
        ],
        tooltip: '%{BKY_CUSTOM_COMMON_COLOR_TOOLTIP}'
      })
    }
  }
}

Blockly.Extensions.registerMutator(
  'common_color_ext',
  Blockly.Constants.commonColor.BORDER_MUTATOR_MIXIN,
  null,
  ['']
)

function hexToRgb(hex) {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null
}

function componentToHex(c) {
  let hex = c.toString(16)
  return hex.length == 1 ? '0' + hex : hex
}

function rgbToHex(r, g, b) {
  let red = parseInt(r)
  let green = parseInt(g)
  let blue = parseInt(b)
  if (isNaN(red)) red = 0
  if (isNaN(green)) green = 0
  if (isNaN(blue)) blue = 0
  return (
    '#' + componentToHex(red) + componentToHex(green) + componentToHex(blue)
  )
}
